<template>
	<Select2Locale
		v-model="valoreCorrente"
		:options="optionsMappate"
		:placeholder="placeholder"
		:disabled="disabled"
	/>
</template>

<script>
import { computed } from 'vue'
import Select2Locale from './Select2Locale.vue'
import { utils } from '../../assets/js/utils';

export default {
	name: 'Select2Array',

	components: {
		Select2Locale
	},

	props: {
		modelValue: [String, Number],
		options: {
			type: Array,
			default: () => []
		},
		optionValue: {
			type: String,
			default: 'ID_OPZIONE_TIPOLOGICA'
		},
		optionLabel: {
			type: [String, Function],
			default: 'DESCRIZIONE'
		},
		filterFn: {
			type: Function,
			default: null
		},
		placeholder: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},

	emits: ['update:modelValue'],

	setup(props, { emit }) {

		const valoreCorrente = computed({
			get: () => props.modelValue,
			set: (newVal) => emit('update:modelValue', newVal)
		});

		const optionsMappate = computed(() => {
			var arr = props.filterFn ? props.options.filter(props.filterFn) : props.options;
			if (typeof props.optionLabel == 'function') {
				return arr.map((item) => ({ id: item[props.optionValue], text: props.optionLabel(item) }));
			}
			return utils.array.toSelect2(arr, props.optionValue, props.optionLabel);
		});

		return { valoreCorrente, optionsMappate };
	},
};
</script>
